import type { InputHTMLAttributes } from "react";

import { cn } from "../../lib/cn";

interface SliderProps extends Omit<InputHTMLAttributes<HTMLInputElement>, "type"> {
  label: string;
  valueLabel: string;
}

export function Slider({ className, label, valueLabel, ...rest }: SliderProps) {
  return (
    <label className="flex flex-col gap-2">
      <span className="flex items-center justify-between text-sm text-ink-soft">
        <span>{label}</span>
        <span className="font-semibold text-ink">{valueLabel}</span>
      </span>
      <input
        className={cn("h-2 w-full cursor-pointer appearance-none rounded-full bg-white/10 accent-accent", className)}
        type="range"
        {...rest}
      />
    </label>
  );
}
